import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetecetor from 'i18next-browser-languagedetector';
import { allAppTranslations } from '../helpers/TranslationHelper';

// <html lang> secili dille ayni kalmali: ekran okuyucu dogru telaffuz etsin diye.
// Detector sirasinda htmlTag, localStorage ve navigator'dan SONRA geldigi icin
// bunu yazmak dil secimini etkilemez.
const syncHtmlLang = (lng?: string) => { document.documentElement.lang = lng ?? 'tr'; };

i18next
    .use(initReactI18next)
    .use(LanguageDetecetor)
    .init({
        debug: true,
        fallbackLng: 'tr',
        resources: allAppTranslations,
    }, () => syncHtmlLang(i18next.resolvedLanguage));

i18next.on('languageChanged', syncHtmlLang);